import type { ShapeId, WallId, WallShape } from '@walls/store/types';
import type { WallsClient } from './client';

export class ShapesApi {
  constructor(private readonly client: WallsClient) {}

  getShapes = (boardId: WallId, key?: string | null) => {
    return this.client.requestJson<WallShape[]>(`/boards/shapes/${boardId}`, boardId, key);
  };

  insertShape = (
    boardId: WallId,
    type: string,
    attributes: Record<string, unknown>,
    zIndex: number,
    key?: string | null
  ) => {
    return this.client.requestJson<WallShape>(`/boards/shapes/${boardId}`, boardId, key, {
      method: 'POST',
      body: JSON.stringify({ attributes, type, zPos: zIndex }),
    });
  };

  updateShape = (
    boardId: WallId,
    shapeId: ShapeId,
    type: string,
    attributes: Record<string, unknown>,
    zIndex: number,
    key?: string | null
  ) => {
    return this.client.requestJson<WallShape>(
      `/boards/shapes/${boardId}/${shapeId}`,
      boardId,
      key,
      {
        method: 'PUT',
        body: JSON.stringify({ attributes, type, zPos: zIndex }),
      }
    );
  };

  deleteShape = (boardId: WallId, shapeId: ShapeId, key?: string | null) => {
    return this.client.requestJson<void>(`/boards/shapes/${boardId}/${shapeId}`, boardId, key, {
      method: 'DELETE',
    });
  };

  updateShapeLocked = (
    boardId: WallId,
    shapeId: ShapeId,
    isLocked: boolean,
    key?: string | null
  ) => {
    return this.client.requestJson<void>(
      `/boards/shapes/locked/${boardId}/${shapeId}`,
      boardId,
      key,
      {
        method: 'PUT',
        body: JSON.stringify({ isLocked }),
      }
    );
  };

  updateShapeZIndexes = (
    boardId: WallId,
    shapes: Array<{ shapeId: ShapeId; zPos: number }>,
    key?: string | null
  ) => {
    return this.client.requestJson<void>(`/boards/shapes/zindex/${boardId}`, boardId, key, {
      method: 'PUT',
      body: JSON.stringify({ shapes }),
    });
  };
}
